import { FilterOption } from '../../../components/_WMS/FilterComponent/types'
import { WarehouseFilterDDL } from '../../../components/Almacen'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../../types/filters'

export const filterOptions: FilterOption[] = [
  {
    key: 'warehouseId',
    label: 'Almacén',
    type: 'custom',
    Component: WarehouseFilterDDL,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer(),
    order: 1
  },
  {
    key: 'zoneName',
    label: 'Zona',
    type: 'text',
    order: 2
  },
  {
    key: 'active',
    label: 'Activo',
    type: 'precreated',
    order: 3
  },
  {
    key: 'externalStorage',
    label: 'Externa',
    type: 'precreated',
    order: 4
  }
]
